import React from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Tooltip from "@mui/material/Tooltip";

const BackButton = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Only triggers when user clicks
  };

  return (
    <Tooltip
      title="Go Back"
      slotProps={{
        popper: {
          sx: {
            zIndex: 9999,
          },
        },
      }}
    >
      <IconButton
        onClick={() => handleBack()}
        size="small"
        sx={{
          border: "1px solid #ccc",
          position: "relative",
          overflow: "hidden",
          isolation: "isolate",
          background: "#001f4c",
          color: "#fff",

          "&::after": {
            content: '""',
            position: "absolute",
            inset: 0,
            background:
              "radial-gradient(circle at center, #001f4c 0%, #6fdeb9 90%, #6fdeb9 100%)",
            opacity: 0,
            transition: "opacity 0.2s ease",
            zIndex: -1,
          },

          "&:hover::after": {
            opacity: 1,
          },
        }}
      >
        <ArrowBackIcon
          sx={{
            color: (t) => t.palette.text.main,
            height: {
              xs: "20px",
              sm: "20", // tablets
              md: "25px", // desktops
            },
            width: "auto",
          }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default BackButton;
